import { useContentDetailsDataProvider } from '../../providers/ContentDetailsDataProvider';
import useAssociatedForms from '../../hooks/useAssociatedForms';
import { Link } from 'foundations-components/transitional/components/Link';
import ContentRoutes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AssociatedFormLabel = () => {
  const {
    contentId
  } = useContentDetailsDataProvider();
  const {
    forms
  } = useAssociatedForms(contentId);
  if (!forms || forms.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: forms === null || forms === void 0 ? void 0 : forms.map(form => /*#__PURE__*/_jsx(Link, {
      href: ContentRoutes.forms(form.id),
      external: true,
      children: form.label
    }, form.id))
  });
};
export default AssociatedFormLabel;